function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { rem } from 'polished';
import React from 'react';
import Box from '../Box';
const IntercomIcon = _ref => {
  let {
    size = 16,
    bg = '#1F8DED',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, _extends({
    as: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: rem(size),
    height: rem(size),
    fill: bg,
    verticalAlign: "middle"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M28 0H4C1.8 0 0 1.8 0 4v24c0 2.2 1.8 4 4 4h24c2.2 0 4-1.8 4-4V4c0-2.2-1.8-4-4-4zm-7.7 5.9c0-.6.5-1.1 1.1-1.1.6 0 1.1.5 1.1 1.1v14.3c0 .6-.5 1.1-1.1 1.1-.6 0-1.1-.5-1.1-1.1V5.9zm-5.4-.6c0-.6.5-1.1 1.1-1.1.6 0 1.1.5 1.1 1.1v15.5c0 .6-.5 1.1-1.1 1.1s-1.1-.5-1.1-1.1V5.3zm-5.3.6c0-.6.5-1.1 1.1-1.1.6 0 1.1.5 1.1 1.1v14.3c0 .6-.5 1.1-1.1 1.1-.6 0-1.1-.5-1.1-1.1V5.9zM4.3 8c0-.6.5-1.1 1.1-1.1.6 0 1.1.5 1.1 1.1v9.6c0 .6-.5 1.1-1.1 1.1-.6 0-1.1-.5-1.1-1.1V8zm23.1 16.3c-.2.1-4.1 3.5-11.4 3.5-7.2 0-11.2-3.3-11.4-3.5-.4-.4-.5-1.1-.1-1.5.4-.4 1.1-.5 1.5-.1.1.1 3.6 2.9 10 2.9 6.5 0 9.9-2.9 10-2.9.4-.4 1.1-.3 1.5.1s.3 1.1-.1 1.5zm.3-6.7c0 .6-.5 1.1-1.1 1.1s-1.1-.5-1.1-1.1V8c0-.6.5-1.1 1.1-1.1.6 0 1.1.5 1.1 1.1v9.6z"
  }));
};
export default IntercomIcon;